
























import {
  DynamicDocumentItem,
  DynamicDocumentItemData,
  InstallationModuleData,
  Material,
} from '@/types';

import Vue, { PropType, VueConstructor } from 'vue';

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>,
  },

  computed: {
    inverters(): Material[] {
      return this.$store.state.materials.inverters.items;
    },
  },
});
